import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hikingPath } from '../utils/paths';
import { SITE_APPS, SITE_NAME } from '../config/siteBranding';
import { HIKING_LANDING_IMAGES } from '../config/hikingLandingAssets';
import './HikingLanding.css';

const HikingLanding = () => {
  const { isAuthenticated, isAdmin, isClubCreator } = useAuth();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const canRegisterClub = isAdmin() || isClubCreator();

  return (
    <div
      className={`hiking-landing${ready ? ' is-ready' : ''}`}
      aria-label={`${SITE_APPS.hiking.name} home`}
    >
      <div
        className="hiking-landing__photo hiking-landing__photo--ridge"
        style={{ backgroundImage: `url(${HIKING_LANDING_IMAGES.ridgeBackground})` }}
        aria-hidden="true"
      />
      <div
        className="hiking-landing__photo hiking-landing__photo--forest"
        style={{ backgroundImage: `url(${HIKING_LANDING_IMAGES.forestBackground})` }}
        aria-hidden="true"
      />
      <div className="hiking-landing__gradient" aria-hidden="true" />
      <div className="hiking-landing__grain" aria-hidden="true" />

      <div className="hiking-landing__card">
        <p className="hiking-landing__eyebrow">{SITE_NAME}</p>
        <h1>{SITE_APPS.hiking.name}</h1>
        <p className="hiking-landing__tagline">
          Publish trails, set the trailhead meetup, vote availability, and share the hike with your
          club.
        </p>

        <ul className="hiking-landing__features">
          <li>Published trails with distance &amp; elevation</li>
          <li>Trailhead meetup &amp; pack list</li>
          <li>Availability voting and group size caps</li>
          <li>Share links &amp; trail photos</li>
        </ul>

        <div className="hiking-landing__actions">
          <Link to={hikingPath('/clubs/list')} className="btn btn-primary">
            Browse hiking clubs
          </Link>
          {isAuthenticated && canRegisterClub && (
            <Link to={hikingPath('/clubs/register')} className="btn btn-secondary">
              Register a club
            </Link>
          )}
          {isAuthenticated && (
            <Link to={hikingPath('/clubs/mine')} className="btn btn-secondary">
              My clubs
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default HikingLanding;
